import React, { useEffect, useState } from 'react'
import { LoaderWrapper, MuiMultiSelect, ReportHeading, ReportOuterWrapper } from '../../../../components'
import ReportsService from '../../../../services/reports.service'
import { useUpdateLhs, useReactQuery, useConditionalQuery } from '../../../../hooks'
import BuyerTable from '../segmentComparison/buyerTable'
import RelativeBrands from '../segmentOverview/relativeBrands'
// import { SegmentProgression} from './components'
import { ContentWrap, Divider, RootWrap, SegmentOfSegmentWrap } from './style'
import { exportExcel_addPercentage, getObjectAsArray, trimFunc, getDistinctValues } from '../../../../util'
import GraphGridTab, { Table } from '../comparisonViewDeepDiveNew/graphGridTab'
import { IconGraphBtn, IconListBtn } from '../../../../assets/images/icons'
import { GRAPH_COLOR_PALLET_V2, GRAPH_COLOR_PALLET_V2_TEXT } from '../../../../constants'
import { ProgressionWrapper as ProgressWrapper } from '../reportCustomTable/style'
import { useGlobalStore } from '../../../../store'
import ProgressionBuyerTable from '../reportSegmentProgression/progressionBuyerTable'

const ReportSegmentAndSegmentOfSegmentV2 = (props) => {
  const [graphPieData, setGraphPieData] = useState([])
  const [state, setState] = useState([])
  const [segmentExcelData, setSegmentExcelData] = useState([])
  const [reportExcelData, setReportExcelData] = useState([])
  const [eventCount, setEventCount] = useState(1)
  const { updateSubLhsApiLoaded } = useUpdateLhs()
  const [show , setShow] = useState('graph')
  const [checkBoxData , setCheckboxData] = useState([]);
  const [segmentData , setSegmentData] = useState([]);
  const [showComparison , setShowComparison] = useState('graph')
  const [maxValue, setMaxValue] = useState(0);
  const [allValuesShow, setAllValuesShow] = useState(true);
  const [segmentValues , setSegmentValues] = useState([]);
  const [filterValue , setFilterValues] = useState([]);
  const [pptData, setPptData] = useState();
  const [finalPptData, setFinalPptData] = useState(null);
  const [updateStateCount, setUpdateStateCount] = useState(0);
  const [isTitleOrdered, setTitleOrderedArray] = useState([]);
  const [colorPalletPieArray, setColorPalletPieArray] = useState([]);
  const [sortedPieColorObject, setSortedPieColorObject] = useState({});

  const { isPPTModalActive } = useGlobalStore()
  const COLOR_ARRAY_NEW = [...GRAPH_COLOR_PALLET_V2, ...GRAPH_COLOR_PALLET_V2_TEXT, ...GRAPH_COLOR_PALLET_V2, ...GRAPH_COLOR_PALLET_V2_TEXT]
 
  const onBtnClick = (activeTab) => {
    setShow(activeTab);
  }

  const onCompareBtnClick = (activeTab) => {
    setShowComparison(activeTab);
  }
  
  const filterChangeFunc = (selectedValue) => {
    setAllValuesShow(prev => selectedValue.length > 0 ? true : false);
    const selectedValues = selectedValue.filter((val) => val !== 'All');

    let data = state?.map((elem) => {
      return {
        ...elem,
        SecondarySegmentSet: {
          ...elem.SecondarySegmentSet,
          SecondarySegment: getObjectAsArray(elem?.SecondarySegmentSet?.SecondarySegment).map((obj) => ({
            ...obj,
            SegmentName: String(obj.SegmentName),
            show: selectedValues.includes(obj.SegmentName)
          }))
        }
      };
    });

    setState(data);
    // setStateValue(data);
    setFilterValues(selectedValue);
  };

  const filterSegmentChangeFunc = (selectedValue) => {
    setAllValuesShow(prev => selectedValue.length > 0 ? true : false);
    const selectedValues = selectedValue.filter((val) => val !== 'All');

    let data = state?.map((elem) => {
      return {
        ...elem,
        SegmentName: String(elem.SegmentName),
        show: selectedValues.includes(elem.PrimarySegmentName)
      };
    });

    setState(data);
    // setStateValue(data);
    setSegmentValues(selectedValue);
  };

  const useReactQueryObject2 = {
    // loadStudySetup
    payloadDetails: {
      queryId: [props.InsightsElementType, props.InsightsElementId, 'PieGraph'],
      urlFunc: ReportsService.getSegmentOverviewElement,
      payload: { insightsElementId: props.InsightsElementId },
    },
    queryDetails: {
      enabled: false,
    },
  }

  const {
    data: data2,
    isLoading: isLoading2,
    isSuccess: isSuccess2,
    isError: isError2,
    error: error2,
    refetch: refetch2,
  } = useConditionalQuery(useReactQueryObject2, {...props, serverData: props?.serverData?.pie})

  const useReactQueryObject1 = {
    // getSegment
    payloadDetails: {
      queryId: [props.InsightsElementType, props.InsightsElementId, 'BarGraph'],
      urlFunc: ReportsService.getSegmentOfSegmentOverviewElement,
      payload: { insightsElementId: props.InsightsElementId },
    },
  }
  const {
    data: data1,
    isLoading: isLoading1,
    isSuccess: isSuccess1,
    isError: isError1,
    error: error1,
    refetch: refetch1,
  } = useConditionalQuery(useReactQueryObject1, {...props, serverData: props?.serverData?.table})

  // Compute segment excel data and (only when necessary) apply colors from graphPieData to state
  useEffect(() => {
    if (!graphPieData) return;
    if (!!state && !!graphPieData) {

      // build excel data from pie and state (if available)
      const segmentExcelDataObj = []
      for (let i = 0; i < graphPieData.length; i++) {
        if(![graphPieData[i].name].includes('REMAINING_VALUE')){
          segmentExcelDataObj.push([
            { value: 'Overall' },
            { value: graphPieData[i].name },
            exportExcel_addPercentage(graphPieData[i].value),
          ])
        }
      }

      if (state && state.length) {
        for (let i = 0; i < state.length; i++) {
          const segmentSet = Array.isArray(state[i]?.SecondarySegmentSet?.SecondarySegment)
            ? state[i].SecondarySegmentSet.SecondarySegment
            : [state[i].SecondarySegmentSet.SecondarySegment]
          for (let j = 0; j < segmentSet.length; j++) {
            if(![state[i].PrimarySegmentName, segmentSet[j].SegmentName].includes('REMAINING_VALUE')){
              segmentExcelDataObj.push([
                { value: state[i].PrimarySegmentName },
                { value: segmentSet[j].SegmentName },
                exportExcel_addPercentage(segmentSet[j].SegmentValue),
              ])
            }
          }
        }
      }
      // setSegmentExcelData(segmentExcelDataObj)
      setSegmentExcelData([...segmentExcelData, ...segmentExcelDataObj])

      // If we have both state and pie colors, apply colors to secondary segments —
      // but only update state if colors actually change (to avoid a render loop).
      if (state && state.length > 0) {
        const colorArray = COLOR_ARRAY_NEW
        const graphPieDataArray = [...graphPieData].map((elem, i) => ({...elem, color:colorArray[i]}))
        const graphPieDataObject = graphPieDataArray.reduce((acc, { name, color }) => {
          acc[name] = color;
          return acc;
        }, {});

        // ensure every segment name has a color
        const stateSegmentArray1 = state.find((elem) => elem.InsightsElementId === props.InsightsElementId)?.SecondarySegmentSet?.SecondarySegment.map(d => ({name:d.SegmentName, value:0})) || []
        if (stateSegmentArray1?.length > 0) {
          for(let i=0; i<stateSegmentArray1.length; i++){
            const name = stateSegmentArray1[i].name
            if(!graphPieDataObject[name]){
              graphPieDataObject[name] = colorArray[graphPieDataArray.length + i]
            }
          }

          // build a new state array immutably with color values
          const newState = state.map((elem) => {
            const newSecondary = (elem.SecondarySegmentSet?.SecondarySegment || []).map((segment) => ({
              ...segment,
              color: graphPieDataObject[segment.SegmentName]
            }));
            return {
              ...elem,
              SecondarySegmentSet: {
                ...elem.SecondarySegmentSet,
                SecondarySegment: newSecondary
              }
            }
          });

          if (updateStateCount < 2) {
            setUpdateStateCount(updateStateCount + 1)
            setState(newState)
          }
        }
      }
    }
  }, [graphPieData, updateStateCount])


  // eventCount only needs incrementing when data initially loads — avoid scheduling on every state/graph change
  useEffect(() => {
    filterChangeFunc(checkBoxData);
  }, [checkBoxData])
    
  useEffect(() => {
    filterSegmentChangeFunc(segmentData);
  }, [segmentData])

  const onSuccessFunc1 = (resp) => {
    const loadTab1Func = (paramData) => {
      let segmentLength = 0
      const getHighestLengthSegment = {
        length: 0,
        index: 0,
        data: [],
        object: {}
      };

      // ===== LOOP 1: Build the longest segment template =====
      for (let i = 0; i < paramData.length; i++) {
        const segs = paramData[i]?.SecondarySegmentSet?.SecondarySegment;
        if (Array.isArray(segs) && segs.length > getHighestLengthSegment.length) {
          getHighestLengthSegment.length = segs.length;
          
          const segmentArr = segs.map(e => ({
            SegmentName: e.SegmentName,
            SegmentValue: ""
          }));

          getHighestLengthSegment.data = segmentArr;

          const template = {};
          segmentArr.forEach(s => {
            template[s.SegmentName] = 0; // ''
          });
          getHighestLengthSegment.object = template;
        }
      }

      // ===== LOOP 2: Apply template to each object =====
      for (let j = 0; j < paramData.length; j++) {
        const record = paramData[j];
        const segmentArray = getObjectAsArray(record?.SecondarySegmentSet?.SecondarySegment);

        if (Array.isArray(segmentArray) && segmentArray.length > 0) {
          // Create a fresh deep copy of template
          const objData = JSON.parse(JSON.stringify(getHighestLengthSegment.object));

          // Override actual values
          segmentArray.forEach(s => {
            objData[s.SegmentName] = s.SegmentValue;
          });

          // Rebuild final array with proper shape
          const finalArr = Object.keys(objData).map(name => ({
            SegmentName: name,
            SegmentValue: objData[name]
          }));

          record.SecondarySegmentSet.SecondarySegment = finalArr;
        }
      }


      let data = paramData?.map((elem) => {
        return {
          ...elem,
          show: true,
          PeriodName: elem.PrimarySegmentName,
          SecondarySegmentSet: {
            ...elem.SecondarySegmentSet,
            SecondarySegment: (elem?.SecondarySegmentSet?.SecondarySegment).map((obj, i) => ({
              ...obj,
              SegmentName: String(obj.SegmentName),
              segmentIndex: i,
              show: true
            }))
          }
        };
      });

      if(['SegmentAndSegmentProgression'].includes(props.InsightsElementType)){
        setPptData(prev => ({ ...prev, progressionContent: data }));
      } else {
        setPptData(prev => ({ ...prev, tableContent: data }));
      }
      setState(data)

      const segmentNames = getObjectAsArray(paramData[0]?.SecondarySegmentSet?.SecondarySegment)
        .map(i => String(i.SegmentName));
      setCheckboxData(segmentNames);

      const reportExcelDataObj = []

      for (let i = 0; i < paramData.length; i++) {
        const segmentSet = getObjectAsArray(
          paramData[i]?.SecondarySegmentSet?.SecondarySegment || []
        )
        for (let j = 0; j < segmentSet.length; j++) {
          reportExcelDataObj.push([
            { value: paramData[i].PrimarySegmentName },
            { value: segmentSet[j].SegmentName },
            exportExcel_addPercentage(segmentSet[j].SegmentValue),
          ])
        }
      }
      if(reportExcelData.length-1 < reportExcelDataObj.length){
        if(reportExcelData.length !== reportExcelDataObj.length){
          setReportExcelData((prev) => ([...prev, ...reportExcelDataObj]))
        }
      }
    }

    loadTab1Func(resp)

    setTimeout(() => {
      updateSubLhsApiLoaded(props)
    }, 2000)
  }

  const onSuccessFunc2 = (resp) => {
    if ( ['SegmentAndSegmentOfSegment', 'SegmentAndSegmentProgression', 'SegmentOfSegmentOverview'].includes(props.InsightsElementType)) {
      let pieData = resp?.map((d) => ({ name: String(d.SegmentName), value: d.SegmentValue })) || []
      const barData = getObjectAsArray(data1[0]?.SecondarySegmentSet?.SecondarySegment || [])

      if (barData.length !== pieData.length) {
        // PATCH TO FIX THE COLOR CODES IF THE VALUE IS 0 AND ITS RESPECTIVE OBJECT IS MISSING
        const pieData2 = barData.map((d) => {
          const pData = pieData.filter((f) => trimFunc(f.name) === trimFunc(d.SegmentName))
          return { name: d.SegmentName, value: pData?.length === 0 ? 0 : pData[0].value }
        })
        pieData = pieData2
      }

      const checkPieTotal = pieData.map((d) => d.value).reduce((a, b) => a + b, 0)
      if (checkPieTotal < 100) {
        pieData.push({ name: 'REMAINING_VALUE', value: 100 - checkPieTotal })
      }
      if(pieData.length > 0){
        pieData = pieData.filter(f => f.value > 0)
        if(pieData.length === 1 && pieData?.[0].name === 'REMAINING_VALUE'){pieData = []}
      }
      
      // if(['SegmentAndSegmentOfSegment'].includes(props.InsightsElementType)){
        const finalExcelArray = []
        for (let j = 0; j < pieData.length; j++) {
          finalExcelArray.push([
            { value: 'Overall' },
            { value: pieData[j].name },
            exportExcel_addPercentage(pieData[j].value),
          ])
        }
        setReportExcelData((prev) => ([...finalExcelArray, ...prev]))
      // }
      
      setPptData(prev => ({...prev, pieContent:pieData}));
      setMaxValue(pieData.length > 0 ? pieData[0].value : 0);

      // setGraphPieData(pieData)

      const sortedPieDataColor = [...pieData].sort((a, b) => b.value - a.value).map((d,i) => ({...d, color: COLOR_ARRAY_NEW[i]}))
      setGraphPieData(sortedPieDataColor)

      setTimeout(() => {
        updateSubLhsApiLoaded(props)
      }, 2000)
    }
  }

  const updatingStateForColors = (pieData) => {
    // Create color map from sorted pie data
    const sortedPieDataColor = [...pieData]
      .sort((a, b) => b.value - a.value)
      .map((d, i) => ({
        ...d,
        color: COLOR_ARRAY_NEW[i],
      }))
      .reduce((obj, item) => {
        obj[item.name] = item.color;
        return obj;
      }, {});

    // Get all segment names
    const getKeys = state
      .map((d1) =>
        d1.SecondarySegmentSet.SecondarySegment.map(
          (d2) => d2.SegmentName
        )
      )
      .flat();

    const getUniqueKeys = getDistinctValues(getKeys);

    // Add colors for missing segments
    let nextColorIndex = Object.keys(sortedPieDataColor).length;

    // SULAMAN
    getUniqueKeys.forEach((segmentName) => {
      if (!sortedPieDataColor[segmentName]) {
        sortedPieDataColor[segmentName] =
          COLOR_ARRAY_NEW[nextColorIndex]

        nextColorIndex++;
      }
    });

    // Update state with clr values
    const changingGridColor = state.map((d1) => ({
      ...d1,
      SecondarySegmentSet: {
        ...d1.SecondarySegmentSet,
        SecondarySegment: d1.SecondarySegmentSet.SecondarySegment.map((d2) => ({
          ...d2,
          clr: sortedPieDataColor[d2.SegmentName],
        })),
      },
    }));

    setSortedPieColorObject(sortedPieDataColor);
    setState(changingGridColor);
  };
  
  useEffect(() => {
    updatingStateForColors(graphPieData)
  }, [graphPieData])

  useEffect(() => {
    if (isSuccess1 && !props?.serverData?.pie) {
      refetch2()
    }
  }, [isSuccess1])

  useEffect(() => {
    if (isSuccess1 && data1?.length >= 0) onSuccessFunc1(data1)
    if (isSuccess2 && data2?.length >= 0) onSuccessFunc2(data2)
  }, [isSuccess1, data1, isSuccess2, data2])

  useEffect(() => {
    if( ['SegmentAndSegmentOfSegment'].includes(props.InsightsElementType) && pptData?.pieContent && pptData?.tableContent){ setFinalPptData(pptData) }
    if( ['SegmentAndSegmentProgression'].includes(props.InsightsElementType) && pptData?.pieContent && pptData?.progressionContent){ setFinalPptData(pptData) }
    if( ['SegmentOfSegmentOverview'].includes(props.InsightsElementType) && pptData?.tableContent ){ setFinalPptData(pptData) }
  }, [pptData])

  const titleOrderedArrayFunc = (array) => {
    orderDataByTitleFunc(array)
  }

  const orderDataByTitleFunc = (orderedTitleArray) => {
    const data = state

    const finalData = data.map(d => {
      const tempArray = new Array(orderedTitleArray.length).fill(null);
      for(let i=0; i<orderedTitleArray.length; i++){
        const found = getObjectAsArray(d?.SecondarySegmentSet?.SecondarySegment).find(s => trimFunc(s.SegmentName) === trimFunc(orderedTitleArray[i]));
        tempArray[i] = { ...found }
      }
      d.SecondarySegmentSet.SecondarySegment = tempArray.map((c, i) => ({...c, color: COLOR_ARRAY_NEW[i]}))
      return d;
    });

    setState(finalData);
    setTitleOrderedArray(true)
  };

  useEffect(() => {
    if(!isTitleOrdered){
      orderDataByTitleFunc()
    }
  }, [isTitleOrdered])

  return (
    <>
      {(!!graphPieData?.length || !!state?.length) && finalPptData && (
        <>
          <ReportHeading
            resetInsightHeight={eventCount}
            downloadId={props?.type}
            {...props}
            pptData={finalPptData}
            downloadIdData={reportExcelData}
            // downloadIdData={segmentExcelData}
            additionalButton={<GraphGridTab onClick={onBtnClick} show={show} GraphIcon={IconGraphBtn} TableIcon={IconListBtn} disableActiveBg={true} />}
          />
          <ReportOuterWrapper>
            <RootWrap id={props?.type}>
              <ContentWrap className='content'>
                <LoaderWrapper
                  loadOnlyApi={props.loadOnlyApi}
                  isLoading={isLoading2}
                  isSuccess={isSuccess2}
                  isError={isError2}
                  error={error2}
                >
                  {graphPieData?.length > 0 && (
                    <RelativeBrands
                      graphPieData={graphPieData}
                      showLegendToolTip={true}
                      activeTab={show}
                      maxValue={maxValue}
                      id={props?.type}
                      sortedPieColorObject={sortedPieColorObject}
                    />
                  )}
                </LoaderWrapper>

                {['SegmentAndSegmentOfSegment', 'SegmentOfSegmentOverview'].includes(props.InsightsElementType) && <LoaderWrapper
                  loadOnlyApi={props.loadOnlyApi}
                  isLoading={isLoading1}
                  isSuccess={isSuccess1}
                  isError={isError1}
                  error={error1}
                >
                  {!isPPTModalActive && <ProgressWrapper>
                    {checkBoxData.length > 0 && (
                      <MuiMultiSelect
                        name={checkBoxData.length}
                        placeholder={`Select Category/Brand`}
                        onChange={(val) => filterChangeFunc(val)}
                        onSelectAll={(val) => {
                          const newVal = val ? checkBoxData : [];
                          filterChangeFunc(newVal);
                        }}
                        data={checkBoxData}
                        value={filterValue}
                        style={{ width: '24%' }}
                        search={true}
                      />
                      )
                    }

                    <GraphGridTab onClick={onCompareBtnClick} show={showComparison} GraphIcon={Table} TableIcon={IconListBtn} disableActiveBg={true} />
                  </ProgressWrapper>}
                  
                  <SegmentOfSegmentWrap className='barGraph'>
                    {state && !!state.length && state?.length > 0 && (
                      <BuyerTable
                        view={showComparison}
                        data={state}
                        isExtraColor={true}
                        // colorPallet={colorPalletArray}
                        // colorPallet={colorPalletPieArray}
                        showLegendToolTip={true}
                        allValuesShow={allValuesShow}
                        sortedPieColorObject={sortedPieColorObject}
                      />
                    )}
                  </SegmentOfSegmentWrap>
                </LoaderWrapper>}

                {['SegmentAndSegmentProgression'].includes(props.InsightsElementType) && <LoaderWrapper
                  loadOnlyApi={props.loadOnlyApi}
                  isLoading={isLoading1}
                  isSuccess={isSuccess1}
                  isError={isError1}
                  error={error1}
                >
                  {!isPPTModalActive && !!state.length && <ProgressWrapper>
                    {checkBoxData.length > 0 && (
                      <MuiMultiSelect
                        name={checkBoxData.length}
                        placeholder={`Select Segments`}
                        onChange={(val) => filterChangeFunc(val)}
                        onSelectAll={(val) => {
                          const newVal = val ? checkBoxData : [];
                          filterChangeFunc(newVal);
                        }}
                        data={checkBoxData}
                        value={filterValue}
                        style={{ width: '100%' , maxWidth: '200px' }}
                        search={true}
                      />
                    )} 

                    {segmentData.length > 0 && (
                      <MuiMultiSelect
                        name={segmentData.length}
                        placeholder={`Select Period`}
                        onChange={(val) => filterSegmentChangeFunc(val)}
                        onSelectAll={(val) => {
                          const newVal = segmentData;
                          filterSegmentChangeFunc(newVal);
                        }}
                        data={segmentData}
                        value={segmentValues}
                        style={{ width: '100%', maxWidth: '200px' }}
                        search={true}
                      />
                    )}

                    <GraphGridTab onClick={onCompareBtnClick} show={showComparison} GraphIcon={Table} TableIcon={IconListBtn} disableActiveBg={true} />
                  </ProgressWrapper>}

                  {!!state.length && (
                    <ProgressionBuyerTable
                      view={showComparison}
                      isExtraColor={true}
                      data={state}
                      // colorPallet={colorPalletArray}
                      showLegendToolTip={true}
                      allValuesShow={allValuesShow}
                      insightsElementType={props.InsightsElementType}
                    />
                  )}
                </LoaderWrapper>}

              </ContentWrap>
            </RootWrap>
          </ReportOuterWrapper>
        </>
      )}
    </>
  )
}

export default ReportSegmentAndSegmentOfSegmentV2
